import styled from 'styled-components';

export const ToRealAccountBannerStyled = styled.div`
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    background-image: var(--bg-image-coin-stack);
    background-color: var(--color-background-secondary);
    background-repeat: no-repeat;
    background-position: right;
    background-size: contain;
    border-radius: 16px;
    box-shadow: var(--shadow-primary);
    
    h5 {
        line-height: 28px;
    }
  
    .description {
        font-size: 14px;
        line-height: 24px;
        color: var(--color-label-secondary);
    }
`;
